import { makeAutoObservable } from 'mobx'
import type { IRowDefault } from 'shared/ui/TableNew'
import type { IResponseIntegrationNumber, IResponseNumberable } from 'entities/Phone/api/types'

export class AircallNumberRow implements IRowDefault {
  id: number
  expanded = false
  is_can_expanded = false
  isMoreExpand = false
  loadingMore = false
  loading = false
  actionsProps = null
  actions = null
  isDisabled = false
  isCheckboxDisabled = false
  ariaLabel = ''
  columnsKeys: string[] = []
  fields: Record<string, unknown> = {}
  withActions = false

  active: boolean
  assigned: boolean
  formatted_number: string
  users: { id: number; full_name: string }[]
  private _numberable: IResponseNumberable
  private _data: IResponseIntegrationNumber

  constructor(data: IResponseIntegrationNumber) {
    this.id = data.id
    this.active = data.active
    this.assigned = data.assigned
    this.formatted_number = data.formatted_number
    this.users = data.users
    this._numberable = data.numberable
    this._data = data

    makeAutoObservable(this)
  }

  setColumnsKeys = (value: string[]) => {
    this.columnsKeys = value
  }

  get isActive() {
    return this.active
  }

  get isAssigned() {
    return this.assigned
  }

  get originalData() {
    return this._data
  }

  get numberable() {
    return this._numberable
  }

  get address() {
    return this.formatted_number
  }
}
